<template>
  <div 
    class="selection-chip"
    :class="{ 'selected': selected }"
    @click="$emit('toggle')"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SelectionChip',
  props: {
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle']
}
</script>

<style scoped>
.selection-chip {
  padding: 10px 20px;
  background-color: #f0f0f0;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0 8px 8px 0;
  display: inline-block;
}

.selection-chip:hover {
  background-color: #e0e0e0;
}

.selection-chip.selected {
  background-color: #e94057;
  color: white;
}
</style> 